import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["readForm"]

  connect() {
    if (this.hasReadFormTarget) {
      this.timer = setTimeout(() => {
        this.readFormTarget.requestSubmit()
      }, 500)
    }
  }

  disconnect() {
    clearTimeout(this.timer)
  }

  onClickOutside(ev) {
    if (this.element.contains(ev.target) || !document.documentElement.contains(ev.target))
      return

    this.element.remove()
  }
}
